export const CANONICAL_ORIGIN = "https://tradeschooltrails.com";
export const WWW_HOST = "www.tradeschooltrails.com";

type BrowserLocation = Pick<Location, "hostname" | "pathname" | "search" | "hash"> & {
  replace(url: string): void;
};

export function canonicalRedirectTarget(location: Pick<BrowserLocation, "hostname" | "pathname" | "search" | "hash">): string | null {
  if (location.hostname.toLowerCase() !== WWW_HOST) return null;

  const pathname = location.pathname.startsWith("/") ? location.pathname : `/${location.pathname}`;
  return `${CANONICAL_ORIGIN}${pathname || "/"}${location.search}${location.hash}`;
}

export function redirectWwwToApex(location: BrowserLocation = window.location): boolean {
  const target = canonicalRedirectTarget(location);
  if (!target) return false;

  location.replace(target);
  return true;
}